import httpClient from "@hd/http-client/http-client";
import { AuthenticationResultDto } from "@hd/types/dto/auth/authentication-result.dto";

interface Params {
  username: string;
  password: string;
  remember: boolean;
}
export const loginRequest = async (data: Params) => {
  const loginResult = await httpClient.post<AuthenticationResultDto>(
    import.meta.env.VITE_HD_API_URL + "/auth/authenticate",
    data,
    {
      // headers: {
      //   [SILENT_REQUEST_HEADER_KEY]: "true",
      // },
    }
  );

  return loginResult.data;
};
